import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PdfService } from '../../../services/pdf.service';
import { OrderService } from '../../../services/entities/order.service';
import { GamaService } from '../../../services/entities/gama.service';
import { OrderWithGamas } from '../../../models/Order';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrl: './print.component.scss'
})
export class PrintComponent {

  constructor(private formBuilder: FormBuilder,
              private orderService: OrderService,
              private gamaService: GamaService,
              private pdfService: PdfService){}

  //Error Vars
  message = {
    status: '',
    text: ''
  }

  //Action Vars
  form_in_progress: boolean = false
  print_form!: FormGroup

  ngOnInit() {
    this.initForm()
  }

  async print(){
    let order: OrderWithGamas
    switch(this.print_form.value.print_type){
      case 'gama':
        order = (await this.orderService.getOrderByOrderNumber(this.print_form.value.order_number).toPromise())!!
        if(!order){
          this.message = {status: 'error', text: 'Orden de trabajo no encontrada.'}
          break
        }
        let gama = order.gamas.find(gama => gama.index == this.print_form.value.gama_number)
        if(!gama){
          this.message = {status: 'error', text: 'Gama no encontrada.'}
          break
        }
        this.pdfService.saveGamaPDF(gama, order)
        this.message = {status: 'success', text: 'Se ha generado el PDF de la gama.'}
        break
      case 'order':
        order = (await this.orderService.getOrderByOrderNumber(this.print_form.value.order_number).toPromise())!!
        if(!order){
          this.message = {status: 'error', text: 'Orden de trabajo no encontrada.'}
          break
        }
        this.pdfService.saveAllOrderGamasPDF(order)
        this.message = {status: 'success', text: 'Se ha generado el PDF de las gamas asociadas.'}
        break
    }
    this.resetForm()
  }

  initForm() {
    this.print_form = this.formBuilder.group(
      {
        print_type: ['gama'],
        order_number: [''],
        gama_number: [''],
      }
    )
  }

  resetForm(){
    this.print_form.reset()
    this.print_form.patchValue({print_type: 'gama'})
  }
}
